module.exports = __webpack_public_path__ + "img/analytics.2e8a0200.svg";